// extracted by mini-css-extract-plugin
module.exports = {"Tooltip":"costarica_Tooltip__25vO3","Indicador":"costarica_Indicador__1cUt9","FadeIn":"costarica_FadeIn__3Wjvt","fadeIn":"costarica_fadeIn__K8fnY"};